import {ReactComponent as SearchIcon} from '../assets/images/icons/Icon_Search.svg';
import {ReactComponent as ChevronDownIcon} from '../assets/images/icons/Icon_KeyboardArrowDown.svg';
import {ReactComponent as ChevronUpIcon} from '../assets/images/icons/Icon_KeyboardArrowUp.svg';
import {ReactComponent as DropDownIcon} from '../assets/images/icons/Icon_ArrowDropDown.svg';
import {ReactComponent as XIcon} from '../assets/images/icons/Icon_Close.svg';
import {ReactComponent as BackIcon} from '../assets/images/icons/Arrow_Back.svg';
import {ReactComponent as HistoryIcon} from '../assets/images/icons/Icon_History.svg';
import {ReactComponent as FilterIcon} from '../assets/images/icons/Icon_Filter.svg';
import {ReactComponent as StarIcon} from '../assets/images/icons/Icon_FavoriteOutline.svg';
import {ReactComponent as ScrollTopIcon} from '../assets/images/icons/Icon_ScrollToTop.svg';
import {ReactComponent as FileIcon} from '../assets/images/icons/Icon_ShowDocument.svg';
import {ReactComponent as SettingsIcon} from '../assets/images/icons/Icon_Settings.svg';
import {ReactComponent as LogoCustomer} from '../assets/images/icons/Logo_Customer.svg';
import {ReactComponent as CloudLinkIcon} from '../assets/images/icons/Icon_LinkToCloud.svg';
import {ReactComponent as DownloadIcon} from '../assets/images/icons/Icon_Download.svg';
import {ReactComponent as WebIcon} from '../assets/images/icons/Icon_Web.svg';
import {ReactComponent as SearchFolder} from '../assets/images/icons/Icon_SavedSearch.svg';
import {ReactComponent as CheckmarkIcon} from '../assets/images/icons/Icon_Checkmark.svg';
import {ReactComponent as AddIcon} from '../assets/images/icons/Add.svg';
import {ReactComponent as DeleteIcon} from '../assets/images/icons/Icon_Delete.svg';
import {ReactComponent as RemoveIcon} from '../assets/images/icons/Icon_Remove_Value.svg';
import {ReactComponent as EditIcon} from '../assets/images/icons/Edit.svg';
import {ReactComponent as CheckboxOffIcon} from '../assets/images/icons/Checkbox_off.svg';
import {ReactComponent as CheckboxOnIcon} from '../assets/images/icons/Checkbox_on.svg';
import {ReactComponent as VerifyIcon} from '../assets/images/icons/Icon_DocType_Verify.svg';
import {ReactComponent as VerifiedIcon} from '../assets/images/icons/Icon_DocType_Verified.svg';
import {ReactComponent as MapIcon} from '../assets/images/icons/Icon_Map.svg';
import {ReactComponent as ZoomInIcon} from '../assets/images/icons/zoom_in.svg';
import {ReactComponent as ZoomOutIcon} from '../assets/images/icons/zoom_out.svg';
import {ReactComponent as MenuIcon} from '../assets/images/icons/Icon_Menu.svg';
import {ReactComponent as CircleDot} from '../assets/images/icons/Circle-dot-regular.svg';
import {ReactComponent as Circle} from '../assets/images/icons/Circle-regular.svg';
import {ReactComponent as Export} from '../assets/images/icons/Icon_Export.svg';
import {ReactComponent as Elipsis} from '../assets/images/icons/Icon_Ellipsis.svg';
import {ReactComponent as Question} from '../assets/images/icons/Icon_Question.svg';
import {ReactComponent as InfoIcon} from '../assets/images/icons/Icon_Info.svg';
import {ReactComponent as ArrowsIcon} from '../assets/images/icons/Icon_Arrows.svg';
import {ReactComponent as Clipboard} from '../assets/images/icons/Icon_CopyToClipboard.svg';
import {ReactComponent as OpenIn} from '../assets/images/icons/Icon_OpenInSource.svg';
import {ReactComponent as Mail} from '../assets/images/icons/Icon_SendLink.svg';
import {ReactComponent as RotateRight} from '../assets/images/icons/Icon_RotateRight.svg';
import {ReactComponent as RotateLeft} from '../assets/images/icons/Icon_RotateLeft.svg';
import {ReactComponent as ItemShared} from '../assets/images/icons/Icon_ItemShared.svg';
import {ReactComponent as ItemNotShared} from '../assets/images/icons/Icon_ItemNotShared.svg';
import {ReactComponent as SharedFolder} from '../assets/images/icons/Icon_SharedFolder.svg';
import {ReactComponent as ArrowBack} from '../assets/images/icons/Icon_ArrowBack.svg';

import {ReactComponent as PDFIcon} from '../assets/images/fileTypes/file-pdf-regular.svg';
import {ReactComponent as WordIcon} from '../assets/images/fileTypes/file-word-regular.svg';
import {ReactComponent as ExelIcon} from '../assets/images/fileTypes/file-excel-regular.svg';
import {ReactComponent as PowerpointIcon} from '../assets/images/fileTypes/file-powerpoint-regular.svg';
import {ReactComponent as ImageIcon} from '../assets/images/fileTypes/file-image-regular.svg';
import {ReactComponent as CodeIcon} from '../assets/images/fileTypes/file-code-regular.svg';
import {ReactComponent as EmailIcon} from '../assets/images/fileTypes/file-envelope-regular.svg';
import {ReactComponent as RawTextIcon} from '../assets/images/fileTypes/file-rawtext-regular.svg';
import {ReactComponent as UndefinedIcon} from '../assets/images/fileTypes/file-undefined-regular.svg';

import React from 'react';

export const Icons = {
    SEARCH: SearchIcon,
    CHEVRON_DOWN: ChevronDownIcon,
    CHEVRON_UP: ChevronUpIcon,
    DROP_DOWN: DropDownIcon,
    X: XIcon,
    BACK: BackIcon,
    FILTER: FilterIcon,
    STAR: StarIcon,
    HISTORY: HistoryIcon,
    SCROLL_TOP: ScrollTopIcon,
    FILE: FileIcon,
    SETTINGS: SettingsIcon,
    LOGO_CUSTOMER: LogoCustomer,
    CLOUD_LINK: CloudLinkIcon,
    DOWNLOAD: DownloadIcon,
    WEB: WebIcon,
    SEARCH_FOLDER: SearchFolder,
    CHECKMARK: CheckmarkIcon,
    MAP: MapIcon,
    ADD: AddIcon,
    CHECKBOX_OFF: CheckboxOffIcon,
    CHECKBOX_ON: CheckboxOnIcon,
    DELETE: DeleteIcon,
    REMOVE: RemoveIcon,
    EDIT: EditIcon,
    CONFIRM: VerifyIcon,
    CONFIRMED: VerifiedIcon,
    ZOOM_IN: ZoomInIcon,
    ZOOM_OUT: ZoomOutIcon,
    MENU: MenuIcon,
    CIRCLE_DOT: CircleDot,
    CIRCLE: Circle,
    EXPORT: Export,
    ELLIPSIS: Elipsis,
    QUESTION: Question,
    INFO: InfoIcon,
    ARROWS: ArrowsIcon,
    CLIPBOARD: Clipboard,
    OPEN_IN: OpenIn,
    MAIL: Mail,
    ROTATE_RIGHT: RotateRight,
    ROTATE_LEFT: RotateLeft,
    SHARED_ITEM: ItemShared,
    NOT_SHARED_ITEM: ItemNotShared,
    SHARED_FOLDER: SharedFolder,
    ARROW_BACK: ArrowBack,
};

export const FILE_TYPES = {
    PDF: PDFIcon,
    WORD: WordIcon,
    EXEL: ExelIcon,
    POWERPOINT: PowerpointIcon,
    IMAGE: ImageIcon,
    CODE: CodeIcon,
    EMAIL: EmailIcon,
    TXT: RawTextIcon,
    UNDEFINED: UndefinedIcon,
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Icons = keyof typeof Icons;

export type IconType = React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;
